<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-card class="box no-display">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Text Book Purchase Report</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="3" md="3" class="pt-3">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="ay" item-value="id"
                            :items="ay_list" item-text="ay" label="Academic Year" outlined />
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="pt-3" v-if="ay">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete rounded dense required v-model="standard" :items="standard_list"
                            item-text="standard" item-value="id" label="Standard" outlined persistent-hint
                            @change="getCourseOffering(standard)" hint="Please Select Standard"></v-autocomplete>

                    </v-col>



                    <v-col cols="12" sm="3" md="3" class="pt-3" v-if="standard != ''">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="subject" item-value="id"
                            :items="subject_list" item-text="course" label="Select Subject" outlined persistent-hint
                            hint="Please Select Subject" />
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="pt-7" v-if="subject != ''">
                        <v-btn class="button" @click="getReport()" :loading="loader">Fetch
                            Report</v-btn>
                    </v-col>
                </v-row>
            </v-card>

            <!-- <span v-if="mainList != '' && mainList != null"> -->
            <v-card v-if="book_purchase_report_list.length > 0">
                <v-card-title>
                    <v-btn v-if="book_purchase_report_list != '' && book_purchase_report_list != null"
                        class="ml-2 mt-5 no-display" rounded color="success" outlined
                        @click="fnExcelReport('my-table-id', 'TextBookPurchaseReport')" :loading="loader">
                        <v-icon color="success">mdi-export</v-icon>Export
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
                        hide-details></v-text-field>
                </v-card-title>
                <v-data-table v-if="book_purchase_report_list.length > 0" :headers="headers1"
                    :items="book_purchase_report_list" :search="search" class="elevation-1" id="my-table-id">
                    <template v-slot:[`item.attachment`]="{ item }">
                        <span v-if="item.attachment != null">
                            <a target="_blank" :href="basepath + item.attachment">
                                <v-icon color="green">mdi-eye</v-icon> <!-- Eye icon for viewing the attachment -->
                            </a>
                        </span>
                        <span v-else>-</span>
                    </template>
                </v-data-table>
            </v-card>
            <!-- </span> -->


            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>




        </v-container>

    </div>
    <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
    data: () => ({
        training_dates: "",
        // extraBreadcrumbItems: [


        // ],
        // breadcrumbClass: "breadcrumb-style1",
        loader: false,
        snackbar_msg: "",
        search: "",
        basepath: null,
        color: "",
        snackbar: false,
        overlay: false,
        title: "",
        standard: "",
        subject: "",
        inst_list: [],
        inst: [],
        ay_list: [],
        standard_list: [],
        subject_list: [],
        ay: "",

        book_purchase_report_list: [],
        show_logo: true,
        headers1: [
            {
                text: "Sr. No.",
                value: "srno",
            },
            {
                text: "Academic Year",
                align: "center",
                value: "academicyear",
            },
            {
                text: "Standard",
                align: "center",
                value: "standard",
            },
            {
                text: "Subject",
                align: "center",
                value: "course",
            },
            {
                text: "Book Name",
                align: "center",
                value: "book_name",
            },
            {
                text: "Publisher",
                align: "center",
                value: "publisher",
            },
            {
                text: "Price",
                align: "center",
                value: "price",
            },
            {
                text: "Front Cover",
                align: "center",
                value: "attachment",
            },
            {
                text: "No. of copies",
                align: "center",
                value: "",
            },
        ],

    }),
    methods: {

        fnExcelReport(id, name) {
            var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
            tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
            tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
            tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
            tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
            tab_text = tab_text + "<table border='1px'>";
            var exportTable = $("#" + id).clone();
            exportTable.find("input").each(function (index, elem) {
                $(elem).remove();
            });
            tab_text = tab_text + exportTable.html();
            tab_text = tab_text + "</table></body></html>";
            var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

            //Save the file
            // var blob = new Blob([tab_text], {
            //     type: "application/vnd.ms-excel;charset=utf-8",
            // });
            // window.saveAs(blob, fileName);
            const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const filename = name + '.xls';

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                // For IE
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                // For modern browsers
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
            }
        },
        showLogo() {
            if (this.show_logo) {
                this.show_logo = false;
            } else {
                this.show_logo = true;
            }
        },
        print() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
                that.$store.state.drawer = true;
            };
            setTimeout(function () {
                window.print();
            }, 100);
        },
        getReport() {
            this.loader = true;
            this.book_purchase_report_list = [];
            const data = {
                ay: this.ay,
                standard: this.standard,
                subject: this.subject
            };
            axios
                .post("/BookReview/fetchTextBookPurchaseReport", data)
                .then((res) => {
                    if (res.data.flag == "Yes") {
                        this.book_purchase_report_list = res.data.book_purchase_report_list;
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.loader = false;
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    this.loader = false;
                })
                .finally(() => { });
        },
        onLoad() {
            axios
                .post("/BookReview/getTextBookPurchaseReport")
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.ay_list = res.data.ay_list;
                        this.standard_list = res.data.standard_list;
                        //this.ay = res.data.curreny_ay;

                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                })
                .finally(() => { });
        },
        getCourseOffering(standard) {
            this.subject = "";
            // alert("standard::"+standard)
            const formData = {
                standard: standard,
                // ay: this.ay,

            };
            axios
                .post("/BookReview/getCourseOfferingsBystdsingle", formData)
                .then((res) => {
                    if (res.data.flag == "Yes") {
                        this.subject_list = res.data.course_list;
                    } else {
                        //   window.console.log(res.data.msg);
                        this.showSnackbar("#b71c1c", "Something went wrong!");
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => { });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },
    mounted() {
        this.onLoad();
        this.basepath = localStorage.getItem("awspath");
    },
    watch: {},
};
</script>
<style scoped>
tr,
td,
th {
    border: 1px solid #ccc;
    width: auto;
    font-size: small;
}

@media print {

    header,
    footer,
    nav,
    date {
        display: none !important;
    }

    /* img {
    width: 100% !important;
  } */

    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card {
        display: none !important;
    }

    .box {
        background-color: white !important;
        /* margin: 8px !important;
    padding: 8px; */
        border: none !important;
        /* overflow: hidden !important; */
    }

    @page {
        size: A4;
        margin-top: none !important;
        padding-top: none;
        /* size: 18in 17in; */
        size: 20in 17in;
    }
}
</style>
